import { z } from 'zod'

export const CRM_TRANSCRIPT_PULL_CONTRACT_VERSION = '1.0.0' as const

/** Provider pull responses intentionally remain passthrough: provider projections evolve independently. */
export const crmTranscriptPullResponseSchema = z.object({
  contract_version: z.literal(CRM_TRANSCRIPT_PULL_CONTRACT_VERSION),
}).passthrough()

export type CrmTranscriptPullResponse = z.infer<typeof crmTranscriptPullResponseSchema>
